import PublicLayout from "@/components/Common/Containers/PublicLayout";
import React from "react";
import { useTranslation } from "react-i18next";
import CreatePasswordForm from "../components/Auth/CreatePasswordForm";

const CreatePassword: React.FC = () => {
  const { t } = useTranslation();

  return (
    <PublicLayout>
      <div className="flex-grow flex items-center justify-center px-4 md:bg-gradient-to-b from-custom-blue to-custom-purple h-full">
        <div className="w-full max-w-4xl flex flex-col md:flex-row">
          {/* Left side - Education program */}
          <div className="hidden order-last md:order-first w-full md:w-1/2 pr-8 md:flex flex-col justify-center">
            <h2 className="text-xl md:text-2xl mb-4">
              {t("auth.sootchy_program.title", {
                partnerName: window?.partner?.title ?? "Sootchy",
              })}
            </h2>
            <ul className="space-y-2">
              <li className="flex items-center py-2">
                <svg
                  className="w-5 h-5 text-green-500 mr-2"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M5 13l4 4L19 7"
                  />
                </svg>
                {t("auth.sootchy_program.benefits.auto_setup")}
              </li>
              <li className="flex items-center py-2">
                <svg
                  className="w-5 h-5 text-green-500 mr-2"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M5 13l4 4L19 7"
                  />
                </svg>
                {t("auth.sootchy_program.benefits.employer_match")}
              </li>
              <li className="flex items-center py-2">
                <svg
                  className="w-5 h-5 text-green-500 mr-2"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M5 13l4 4L19 7"
                  />
                </svg>
                {t("auth.sootchy_program.benefits.tax_free_growth")}
              </li>
            </ul>
          </div>

          {/* Right side - Login form */}

          {/* <div className="font-outfit w-full md:w-[420px] md:mt-[40px]">
            <div className="md:shadow-lg bg-white rounded-[24px] md:p-[32px]">
              <h1 className="block font-semibold text-[32px] leading-[127%] ">
                Create new password
              </h1>
              <p className="py-[16px] text-[18px] leading-[127%]">
                Create a new password to ensure your account stays safe.
              </p>
              <CreatePasswordForm />
            </div>
          </div> */}

          <CreatePasswordForm />
        </div>
      </div>
    </PublicLayout>
  );
};

export default CreatePassword;
